import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Container from "@mui/material/Container";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateItemButton from "../../../components/CreateItemButton.js";
import DataNotFound from "../../../components/DataNotFound.js";
import ErrorDialog from "../../../components/dialogs/ErrorDialog.js";
import LoadingBackdrop from "../../../components/LoadingBackdrop.js";
import PageList from "../../../components/page-list/PageList.js";
import { useUser } from "../../../components/UserContext.js";
import { getCharacters } from "../../../lib/apiConfig.js";
import { PAGE_LIST_CONTAINER_SX, ROUTES } from "../../../lib/constants.js";
import { filterVisibleCharacters } from "../../../lib/filterVisibleCharacters.js";
import { useFetch } from "../../../lib/hooks/useFetch.js";

export default function CharactersList({ locales }) {
  const { canEdit, canViewOtherHidden, hostEmployeeId, runId } = useUser();
  const navigate = useNavigate();
  const [characters, setCharacters] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { isFetching } = useFetch({
    endpoint: getCharacters({ runId }),
    mustFetch: !characters,
    onSuccess: (response) => {
      const visibleCharacters = filterVisibleCharacters({
        canViewOtherHidden,
        characters: response,
        hostEmployeeId,
      });

      setCharacters(visibleCharacters);
    },
    onFail: (error) => {
      setErrorMessage(error.message);
      setShowError(true);
    },
  });

  return isFetching ? (
    <LoadingBackdrop />
  ) : (
    <Container disableGutters sx={PAGE_LIST_CONTAINER_SX}>
      {canEdit && (
        <CreateItemButton
          icon={<PersonAddAlt1Icon />}
          onClick={() =>
            navigate(`/${ROUTES.PLOTS.BASE}/${ROUTES.PLOTS.CHARACTERS.CREATE}`)
          }
          text={locales["plots.characters.create"]}
        />
      )}
      {Array.isArray(characters) ? (
        <PageList
          items={characters}
          locales={locales}
          pageName="characters"
          primaryTextProp="name"
          searchBoxLabel={locales["plots.characters.search"]}
          secondaryTextProp="host.serial"
        />
      ) : (
        <DataNotFound text={locales["plots.characters.notFound"]} />
      )}
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
